import { ArrowRight } from 'lucide-react';
import React from 'react';
import { array, string } from 'prop-types';

import css from './ReadySection.module.css';

import ResponsiveImage from '../../../components/ResponsiveImage/ResponsiveImage';
import { FormattedMessage } from '../../../util/reactIntl';

const ReadySection = props => {
  const { sectionId, sectionData } = props;
  const titleText = (sectionData && sectionData[0]?.title?.content) || '';
  const descriptionText = (sectionData && sectionData[0]?.description?.content) || '';
  const backgroundImage = sectionData && sectionData[0]?.appearance?.backgroundImage;

  const getVariantNames = img => {
    const { variants } = img?.attributes || {};
    return variants ? Object.keys(variants) : [];
  };

  const SignupLink = () => {
    const ROOT_URL = process.env.REACT_APP_MARKETPLACE_ROOT_URL;
    const port = process.env.REACT_APP_DEV_API_SERVER_PORT;
    const useDevApiServer = process.env.NODE_ENV === 'development' && !!port;
    const baseURL = useDevApiServer ? `http://localhost:${port}` : ROOT_URL;

    const redirect = `${baseURL}/api/auth/auth0?isLogin=${false}&userType=provider&defaultReturn=${encodeURIComponent(
      '/'
    )}`;

    return (
      <button onClick={e => (window.location = redirect)}>
        <span>
          <FormattedMessage id="ProviderLandingPage.whatSection.becomeProvider" />
          <ArrowRight />
        </span>
      </button>
    );
  };
  return (
    <section id={sectionId} className={css.container}>
      <div className={css.text}>
        <div className={css.left}>
          <div>
            <h2>{titleText}</h2>
          </div>
        </div>
        <div className={css.right}>
          <div className={css.ctaSplit}>
            <p>
              <FormattedMessage id="ProviderLandingPage.readyGetStarted" />
            </p>
            <SignupLink />
            {/* <a href={sectionData[0]?.callToAction?.href}>
              {sectionData[0]?.callToAction?.content}
              <ArrowRight />
            </a> */}
          </div>
        </div>
      </div>
      <div className={css.imageContainer}>
        <ResponsiveImage
          className={css.backgroundImage}
          alt="Background image"
          image={backgroundImage}
          variants={getVariantNames(backgroundImage)}
        />
        <div className={css.imageOverlay}></div>
      </div>
      <div className={css.ctaOverlay}></div>
    </section>
  );
};

ReadySection.defaultProps = {
  sectionData: {},
};

ReadySection.propTypes = {
  sectionId: string.isRequired,
  sectionData: array,
};

export default ReadySection;
